import React from "react"

export const MinusIcon = ({
  size = 1,
  color = "#034055",
  strokeWidth = "2.5",
  className = undefined,
}) => {
  return (
    <svg
      className={className}
      width={24 * size}
      height={24 * size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5 12.018h14.035"
        stroke={color}
        strokeWidth={strokeWidth}
        fill="none"
        fillRule="evenodd"
      />
    </svg>
  )
}
